import {pxToRem} from '../../../utills/pxToRem'
import sizes from '../../../theme/foundations/sizes'
import {fonts} from '../../../theme/foundations/fonts'

const {md} = sizes.container

export const accordionHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: pxToRem(5),
    paddingRight: pxToRem(8),

    h2: {
        fontSize: pxToRem(14),
        fontWeight: 500,
        fontFamily: fonts.primary,
        letterSpacing: pxToRem(2),
        textTransform: 'uppercase',
        lineHeight: 'normal',
        color: 'black',
        margin: 0,
        [`@media (min-width: ${md})`]: {
            fontSize: pxToRem(16)
        }
    },

    '.chakra-icon': {
        width: pxToRem(21),
        height: pxToRem(21),
        marginRight: pxToRem(0),
        paddingTop: pxToRem(5)
    }
}

export const accordionPanelContentStyles = {
    paddingLeft: 0,

    '.chakra-checkbox': {
        paddingLeft: pxToRem(10),

        '.chakra-checkbox__label': {
            fontSize: pxToRem(10),
            fontWeight: 400,
            fontFamily: fonts.primary,
            letterSpacing: pxToRem(1),
            marginTop: pxToRem(3),
            [`@media (min-width: ${md})`]: {
                fontSize: pxToRem(12)
            }
        }
    }
}

export const accordionListBtnStyles = {
    fontSize: pxToRem(12),
    fontWeight: 500,
    fontFamily: fonts.primary,
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(2), pxToRem(2)],
    textTransform: 'uppercase',
    color: 'cav_calltoaction_darkred',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: `${pxToRem(15)} !important`,
    height: pxToRem(15),
    [`@media (min-width: ${md})`]: {
        fontSize: pxToRem(14)
    }
}

export const iconTitleStyle = {
    textAlign: 'center',
    marginTop: pxToRem(10),
    marginBottom: '0',
    fontFamily: fonts.primary,
    fontSize: pxToRem(12),
    fontWeight: '400',
    letterSpacing: pxToRem(0.5),
    textTransform: 'uppercase',
    width: '100%',
    display: 'block'
}
